"use client";

/**
 * Gradient divider between homepage sections.
 * Replaces hard border-y lines with a breathing gradient transition.
 * Three variants to break visual monotony.
 */

type DividerVariant = "purple-cyan" | "cyan-green" | "subtle";

const GRADIENTS: Record<DividerVariant, string> = {
  "purple-cyan":
    "linear-gradient(90deg, transparent 0%, color-mix(in oklab, var(--accent) 22%, transparent) 50%, transparent 100%)",
  "cyan-green":
    "linear-gradient(90deg, transparent 0%, color-mix(in oklab, var(--accent) 16%, transparent) 30%, color-mix(in oklab, var(--good) 16%, transparent) 70%, transparent 100%)",
  subtle:
    "linear-gradient(90deg, transparent 0%, var(--line) 50%, transparent 100%)",
};

export default function SectionDivider({
  variant = "subtle",
}: {
  variant?: DividerVariant;
}) {
  return (
    <div
      aria-hidden
      className="mx-auto h-px w-full max-w-5xl"
      style={{ background: GRADIENTS[variant] }}
    />
  );
}
